<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-11-10 15:40:08
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-03-29 12:03:53
-->

<template>
  <div class="innovative innovative-aneuflow" ref="aneuflow" :class="{textj: language != 'en'}">
    <div class="innovative-bj scrollBox">
      <img class="wid100" :src="require('@/assets/images/pc/innovate/product-list-bj.png')" alt="" srcset="">
      <div class="innovative-bj-title center_up_down_left_right" v-html="$t('product.aneuflow.title')"></div>
    </div>
    <div class="p-t-60 overhid">
      <div class="innovative-container">
        <div class="innovative-wrap-item flex p-b-150" :class="{align_items_center: language != 'en'}">
          <div class="flex_1">
            <img class="m-t--10" :src="$t('product.aneuflow.list[0].img')" alt="" srcset="">
          </div>
          <div class="flex_1 p-l-40">
            <div class="innovative-item-title" v-html="$t('product.aneuflow.list[0].title')"></div>
            <div class="p-t-46 p-b-30 textj">
              <p v-for="item, index in $t('product.aneuflow.list[0].des')" :key="index" v-html="item"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="innovative-wrap-item p-t-0 posrel aneuflow-characteristics">
        <img class="wh100" :src="$t('product.aneuflow.list[1].img')" alt="" srcset="">
        <div class="posabs t-0 wh100 innovative-container flex justify_content_center align_items_center p-t-50 p-b-50">
          <div class="innovative-characteristics flex align_items_center justify_content_between">
            <div class="trans-list wid100">
              <div class="innovative-item-title" v-html="$t('product.aneuflow.list[1].title')"></div>
              <el-row :gutter="60" class="p-t-46 flex justify_content_between">
                <el-col v-for="item, index in $t('product.aneuflow.list[1].des')" :key="index">
                  <div class="innovative-wrap-item-title p-b-20" v-html="item.title"></div>
                </el-col>
              </el-row>
              <el-row :gutter="60" class="flex justify_content_between">
                <el-col v-for="item, index in $t('product.aneuflow.list[1].des')" :key="index">
                  <p class="innovative-characteristics-item" v-for="$item, $index in item.list" :key="$index" v-html="$item"></p>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
      <div class="aneuflow-advantages p-t-78">
        <div class="innovative-container">
          <div class="innovative-wrap-item">
            <div class="innovative-item-title" v-html="$t('product.aneuflow.list[2].title')"></div>
            <div class="flex align_items_center justify_content_center innovative-aneuflow-m-h">
              <img class="" :src="$t('product.aneuflow.list[2].img1')" alt="" srcset="">
            </div>
          </div>
          <div class="innovative-wrap-item p-t-98">
            <div class="flex align_items_center justify_content_center">
              <img class="" :src="$t('product.aneuflow.list[2].img2')" alt="" srcset="">
            </div>
          </div>
        </div>
      </div>
      <div class="innovative-container">
        <div class="innovative-wrap-item p-t-50 article">
          <div class="innovative-item-title" v-html="$t('product.aneuflow.article.title')"></div>
          <div class="p-t-15">
            <p class="p-t-15" v-for="item, index in $t('product.aneuflow.article.des')" :key="index" v-html="`${index + 1}. ${item}`"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      box1: true,
      box2: true,
      box3: true,
      box4: true
    }
  },
  computed: {
    ...mapGetters(['language', 'scrollTop', 'clientHeight'])
  },
  watch: {
    scrollTop (newV, oldV) {
      // this.setBoxH()
    }
  },
  mounted () {
    this.$nextTick(() => {
      // let timer = setTimeout(() => {
      //   clearTimeout(timer)
      //   timer = null
      //   this.setBoxH()
      // }, 50)
    })
  },
  methods: {
    setBoxH () {
      if (this.clientHeight >= this.$refs.box1.offsetTop || this.scrollTop >= this.$refs.box1.offsetTop - this.clientHeight) {
        this.box1 = false
      }
      if (this.clientHeight >= this.$refs.box2.offsetTop || this.scrollTop >= this.$refs.box2.offsetTop - this.clientHeight) {
        this.box2 = false
      }
    }
  }
}
</script>

<style lang="less">
@import "~@/styles/pc/products.less";
</style>

<style lang="less" scoped>
.pc .innovative-aneuflow {
  padding-bottom: 50PX;
  .aneuflow-advantages {
    background: #F8FBFF;
    padding-top: 70PX;
    padding-bottom: 52PX;
  }
  .innovative-characteristics {
    padding: 50PX 10%;
  }
  .innovative-aneuflow-m-h {
    background: #FFFFFF;
    box-shadow: 0PX 4PX 4PX rgba(81,170,255,0.1);
    padding: 35PX 125PX;
  }
}
</style>
<style lang="less" scoped>
@media screen and (max-width: 1600PX) {
  .pc.en .innovative-aneuflow {
    .aneuflow-characteristics {
      height: 500PX;
    }
  }
}
@media screen and (max-width: 1440PX) {
  .pc .innovative-aneuflow {
    .aneuflow-characteristics {
      height: 500PX;
    }
  }
}
</style>
